import "./Loader.scss";

const Loader = ({ id }) => {
  return (
    <div className="loader-container" id={id}>
      <div className="loader" />
    </div>
  );
};

export default Loader;
